var _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddFlashSale(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.368 15.8926C14.1649 15.8926 13.9618 16.0772 13.9618 16.6958C13.9618 17.3143 14.1649 17.499 14.368 17.499C14.5711 17.499 14.7742 17.3143 14.7742 16.6958C14.7742 16.0772 14.5711 15.8926 14.368 15.8926Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.63191 12.8457C9.42881 12.8457 9.22571 13.0304 9.22571 13.6489C9.22571 14.2675 9.42881 14.4521 9.63191 14.4521C9.83501 14.4521 10.0381 14.2675 10.0381 13.6489C10.0381 13.0304 9.83501 12.8457 9.63191 12.8457Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0274 8.51439C16.9926 6.26695 15.7833 4.28854 15.1271 3.02456C14.4164 1.65549 14.1835 0.80654 14.1817 0.799784L13.9702 0L13.2146 0.337001C13.1263 0.376364 11.0388 1.32834 9.86915 3.66764C9.282 4.84201 9.16456 6.14952 9.16949 7.03953C9.17235 7.55748 8.80537 8.00723 8.29694 8.10889C7.94047 8.18011 7.57377 8.0693 7.31648 7.81201L5.90913 6.40465L5.425 7.07223C5.37475 7.14152 4.19161 8.77323 3.97622 9.09925C2.9244 10.6915 2.37595 12.5462 2.39016 14.463C2.40921 17.023 3.41594 19.4214 5.2249 21.2165C7.03376 23.0115 9.43987 24 12 24C17.299 24 21.61 19.6889 21.61 14.39C21.61 12.4687 20.6687 10.3271 19.0274 8.51439ZM14.368 18.4952C13.3894 18.4952 12.6508 17.8489 12.6508 16.6949C12.6508 15.5502 13.3894 14.8946 14.368 14.8946C15.3466 14.8946 16.0852 15.5501 16.0852 16.6949C16.0852 17.8489 15.3466 18.4952 14.368 18.4952ZM13.4264 11.9404H14.9866L10.5736 18.4028H9.0134L13.4264 11.9404ZM7.9148 13.6483C7.9148 12.5036 8.65336 11.8481 9.63199 11.8481C10.6106 11.8481 11.3492 12.5036 11.3492 13.6483C11.3492 14.8023 10.6106 15.4486 9.63199 15.4486C8.65336 15.4486 7.9148 14.8023 7.9148 13.6483Z",
    fill: "url(#paint0_linear_6525_8412)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6525_8412",
    x1: 11.9999,
    y1: -0.0000586439,
    x2: 11.9999,
    y2: 23.9995,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DED3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2020FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddFlashSale);
export default __webpack_public_path__ + "static/media/add_flash_sale.d927d470a105c05c4c0131bc66c23919.svg";
export { ForwardRef as ReactComponent };